import Vue from 'vue'
import Template from './template.vue'

const ChooseFileConstructor = Vue.extend(Template)

/**
 *
 * @param {import('vue').VueConstructor} vue
 */
const install = (vue) => {
  const ChooseFile = new ChooseFileConstructor()
  ChooseFile.$mount()
  document.body.appendChild(ChooseFile.$el)
  vue.prototype.$chooseFile = (...p) => ChooseFile.chooseFile(...p)
  vue.$chooseFile = vue.prototype.$chooseFile
}

export default install
